import CorneredBox from "../CorneredBox";
import { Container } from "react-bootstrap";
import Breadcrumb, { BreadcrumbItem } from "../Breadcrumb";
import HeadingText1 from "../HeadingText1";
import HeadingText2 from "../../styled/HeadingText2";
import { FC, useEffect } from "react";
import Text from "../../styled/Text";
import { ButtonStyled } from "../Button.styled";
import { useRouter } from "next/router";
import Head from "next/head";
import { titleCase } from "../../utils/titleCase";
import { allConcernedAreas } from "../../constants/concernedAreasForLegalConsultation";
import { withRouter } from "next/router";
import { City } from "../../all-city";

interface Props {
  concernedArea?: string;
  city: string;
  showMore?: boolean;
  handleClickShowMore: () => void;
  urlYoutube: string;
}

function getSchema(o: any) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(o) }}
    />
  );
}

const CityLawyerComponent: FC<{ title: string; content: string }> = ({
  title,
  content,
}) => {
  return (
    <>
      <HeadingText2
        fontSize="lg"
        fontFamily="montserrat"
        weight="bold"
        className="mb-3 mt-4"
      >
        {title}
      </HeadingText2>
      <Text
        as="div"
        fontSize={"mdl"}
        weight="400"
        color="secondary2"
        className="mb-4"
        style={{ whiteSpace: "pre-line" }}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </>
  );
};

const CityLawyerHeader: FC<Props> = ({
  concernedArea,
  city,
  showMore,
  handleClickShowMore,
  urlYoutube,
}) => {
  const concernedAreas = allConcernedAreas
    .filter(
      (concernedArea, index) =>
        concernedArea !== "Other Legal Problem" &&
        concernedArea !== "Other Property Issues" &&
        concernedArea !== "Any other Business Legal matter" &&
        allConcernedAreas.indexOf(concernedArea) === index
    )
    .sort();
  const router = useRouter();
  const allcities = City.getCitiesOfCountry("IN");

  let indexOfCurrentCity: any;
  allcities?.map((citi: any, index: any) => {
    if (city === citi.name) {
      indexOfCurrentCity = index;
    }
  });

  const nextCities = allcities.slice(
    indexOfCurrentCity + 1,
    indexOfCurrentCity + 20
  );

  const remappedConcernedArea = `${
    concernedArea == "Gst"
      ? "GST"
      : concernedArea == "Nclt Matter"
      ? "NCLT"
      : concernedArea == "Rera Act"
      ? "RERA"
      : concernedArea == "Trademark And Copyrights"
      ? "Trademark and Copyrights"
      : concernedArea == "Labour And Employment"
      ? "Labour and Employment"
      : concernedArea == "Investment And Fundraise"
      ? "Investment and Fundraise"
      : concernedArea == "Alimony And Maintenance"
      ? "Alimony and Maintenance"
      : concernedArea
  }`;

  const breadcrumbItems: BreadcrumbItem[] = [
    {
      label: "Home",
      link: "/",
    },
    {
      label: "Find Lawyers",
      link: "/find-all-lawyers-in-cities",
    },
    {
      label: `Find ${remappedConcernedArea} Lawyers`,
      link: `/find-all-lawyers-in-cities/${concernedArea
        ?.toLowerCase()
        .replace(/ /g, "-")}`,
    },
    {
      label: `Find ${remappedConcernedArea} Lawyers in ${city}`,
      link: null,
    },
  ];

  const breadcrumbWOCAItems: BreadcrumbItem[] = [
    {
      label: "Home",
      link: "/",
    },
    {
      label: "Find Lawyers",
      link: "/find-all-lawyers-in-cities",
    },
    {
      label: `Find Lawyers in ${city}`,
      link: null,
    },
  ];

  const schemaObject: any = {
    "@context": "https://schema.org",
    "@type": "Product",
    name: !concernedArea
      ? `Lawyers and Legal Advisors in ${city} | ezyLegal`
      : `${concernedArea} Lawyers and Legal Advisors in ${city} | ezyLegal`,
    image:
      "https://cms.ezylegal.in/wp-content/uploads/2021/06/cases_black_24dp.svg",
    description: !concernedArea
      ? `Hire experienced lawyer in ${city} to get the best and right legal advice instantly also consult experienced and verified legal advisors in ${city}.`
      : `ezyLegal helps you find ${concernedArea} legal advisor in your location basis your need like matrimonial & property disputes, divorce, real estate, employment & criminal law matters`,
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.8",
      ratingCount: "83",
      worstRating: "1",
      bestRating: "5",
    },
  };
  return (
    <>
      <Head>
        {getSchema(schemaObject)}
        <link
          rel="canonical"
          href={`https://www.ezylegal.in/city-lawyers${router?.asPath}`}
        />
        <meta property="og:type" content="product" />
        <meta
          property="og:url"
          content={`https://www.ezylegal.in/city-lawyers${router?.asPath}`}
        />
        <meta
          property="og:image"
          content="https://ezylegal.in/images/EzyLegal_final_logo-Kit-08_128x128.jpg"
        />
        <meta
          property="og:title"
          content={
            !concernedArea
              ? `Lawyers and Legal Advisors in ${city} | ezyLegal`
              : `${remappedConcernedArea} Lawyers and Legal Advisors in ${city} | ezyLegal`
          }
        />
        <meta
          property="og:description"
          content={
            !concernedArea
              ? `Hire experienced lawyer in ${city} to get the best and right legal advice instantly also consult experienced and verified legal advisors in ${city}.`
              : `ezyLegal helps you find ${remappedConcernedArea} legal advisor in ${city} basis your need also get help for matrimonial & property disputes, divorce, real estate, employment & criminal law matters`
          }
        />
        <meta
          property="title"
          content={
            !concernedArea
              ? `Lawyers and Legal Advisors in ${city} | ezyLegal`
              : `${remappedConcernedArea} Lawyers and Legal Advisors in ${city} | ezyLegal`
          }
        />
        <meta
          name="description"
          content={
            !concernedArea
              ? `Hire experienced lawyer in ${city} to get the best and right legal advice instantly also consult experienced and verified legal advisors in ${city}.`
              : `ezyLegal helps you find ${remappedConcernedArea} legal advisor in ${city} basis your need also get help for matrimonial & property disputes, divorce, real estate, employment & criminal law matters`
          }
        />
        <meta name="robots" content="index, follow" />
        <meta name="copyright" content="ezyLegal" />
        <meta name="reply-to" content={"contact@ezylegal.in"} />
        <title>
          {!concernedArea
            ? `Lawyers and Legal Advisors in ${city} | ezyLegal`
            : `${remappedConcernedArea} Lawyers and Legal Advisors in ${city} | ezyLegal`}
        </title>
      </Head>
      <CorneredBox
        // marginTop="-25px"
        paddingTop="20px"
        zIndex={15}
        position="relative"
        paddingBottom="30px"
        bgColor="lightSkyBlue"
      >
        <Container className="pt-1">
          <Breadcrumb
            items={concernedArea ? breadcrumbItems : breadcrumbWOCAItems}
          />
          <HeadingText2
            fontSize="xxxl"
            fontFamily="montserrat"
            weight="bold"
            className="mb-4"
          >
            {`Talk to${
              concernedArea
                ? `
             ${remappedConcernedArea}`
                : ""
            } Lawyers and Legal Advisors in ${city}`}
          </HeadingText2>
          {concernedArea == "Business" && (
            <Text
              as="div"
              fontSize={"mdl"}
              weight="400"
              color="secondary2"
              style={{ whiteSpace: "pre-line" }}
              dangerouslySetInnerHTML={{
                __html: `Business Legal Experts are accomplished lawyers who understands the legal pain points of the business users. Our legal experts give the right business legal advice for Company Matters, Trademark & Copyrights, Law & Regulation, Investment & Fundraise, Taxation & Compliance, or getting your Term Sheet & Shareholder Agreement reviewed.            

              Get legal advice from ezyLegal's top-rated legal experts and the best business lawyers in ${city}. Consult ${city}’s top-rated business legal consultation lawyers, who have a wide range of experience practicing in the High Courts and before the Supreme Court of India.
              
              This network of business legal consultants provides benefits to the clients as a single-window service provider, dealing with all kinds of business legal matters under one umbrella. The advocates are available 24x7. Talk to the best business legal experts from ${city} and nearby areas.`,
              }}
            />
          )}
          {concernedArea == "Divorce" && (
            <Text
              as="div"
              fontSize={"mdl"}
              weight="400"
              color="secondary2"
              style={{ whiteSpace: "pre-line" }}
              dangerouslySetInnerHTML={{
                __html: `ezyLegal offers legal consultations and legal advice on matters related to divorce and child custody. Consulting an experienced divorce lawyer is essential as divorce is one of the most important decisions you ever make. The platform offers comprehensive and holistic legal solutions tailored to the needs and specifications of each customer going through this process. The divorce attorneys at ezyLegal assist with issues such as mutual divorce, contested divorce, judicial separation, alimony and maintenance.            

              Get online legal advice from ezyLegal's experienced Divorce and Child Custody lawyers in ${city} and nearby locations in ${city}. Consult ${city}’s top-rated divorce and child custody lawyers, who have a wide range of experience practicing in the High Courts and before the Supreme Court of India.
              
              Our goal is to transform the legal experience by providing on-demand high-quality, affordable legal services to meet all your needs. Our advocates are available 24x7. Speak to the best legal experts from ${city} and nearby areas.`,
              }}
            />
          )}
          {concernedArea == "Property Disputes" && (
            <Text
              as="div"
              fontSize={"mdl"}
              weight="400"
              color="secondary2"
              style={{ whiteSpace: "pre-line" }}
              dangerouslySetInnerHTML={{
                __html: `ezyLegal has renowned property dispute lawyers on board who provides the best solutions to property disputes. Our attorneys have years of experience practicing in the High Court and Supreme Court and are based in ${city}. We have the perfect team of advocates who provide services like settling property disputes, property registration, property verification, and legal advice on property leasing.            

              Get practical legal advice from ezyLegal's skilled legal advisor and the best property dispute lawyers in ${city}. 
              
              We offer legal assistance 24x7 and help with document verification for documents including lease agreements, rental contract paperwork and legal documents pertaining to a property. Talk to the best property dispute advocates in ${city} and have your queries answered instantly.`,
              }}
            />
          )}
          {concernedArea == "Trademark And Copyrights" && (
            <Text
              as="div"
              fontSize={"mdl"}
              weight="400"
              color="secondary2"
              style={{ whiteSpace: "pre-line" }}
              dangerouslySetInnerHTML={{
                __html: `Trademark and Copyright lawyers are specialists who are dedicated to providing excellent client service. ezyLegal provides a wide range of services, such as trademark registration, trademark renewal, response to trademark objections, and copyright registrations.            

              ezyLegal has some of the best advocates in ${city} who make sure the client’s brand and reputation are protected to gain an economic advantage for their business. We have a team of 9,000+ professional lawyers and verified experts practicing in the High Court and Supreme Court of India. 
              
              The advocates from ${city} offer a comprehensive legal solution that safeguards and protects a wide range of consumer brands. Consult top-rated Trademark and Copyright lawyers from ${city} and nearby areas who will give you the right and neutral advice.`,
              }}
            />
          )}
          {concernedArea == "Consumer Protection" && (
            <Text
              as="div"
              fontSize={"mdl"}
              weight="400"
              color="secondary2"
              style={{ whiteSpace: "pre-line" }}
              dangerouslySetInnerHTML={{
                __html: `Our consumer protection lawyers deal with consumer fraud matters such as false or misleading advertising, defective products, data privacy breaches, and other unfair trade practices.            

              ezyLegal will put you in touch with the best consumer protection lawyers in ${city} who have experience practising in the High Courts and the Supreme Court of India. The modern law consultation at ezyLegal offers the right kind of legal advice at affordable rates.
              
              We have some of the best consumer protection advocates on our panel. Connect with ezyLegal consultants in ${city} and nearby areas for consumer protection and any consumer dispute matters.`,
              }}
            />
          )}
          {concernedArea == "Will" && (
            <Text
              as="div"
              fontSize={"mdl"}
              weight="400"
              color="secondary2"
              style={{ whiteSpace: "pre-line" }}
              dangerouslySetInnerHTML={{
                __html: `ezyLegal's Will drafting services would assist you end-to-end in drafting a Will and getting it Registered / Notarized with our top-notch legal professional services. Our platform offers customized online Will drafting and registration services coupled with document reviews which make the entire process simpler, trusted, convenient, and affordable.            

              Get online legal advice from legal experts on Will-related matters in ${city}. Consult ${city}’s top-rated lawyers, who are practicing in the High Courts and before the Supreme Court of India.
              
              ezyLegal is the best choice for availing Will Registration services in ${city} as customers can avail it anywhere and at any time. Our platform has made it feasible for you to check & verify the Will document online from the comfort of your home. ezyLegal assures you the utmost privacy &confidentiality.`,
              }}
            />
          )}
          {concernedArea == "Alimony And Maintenance" && (
            <Text
              as="div"
              fontSize={"mdl"}
              weight="400"
              color="secondary2"
              style={{ whiteSpace: "pre-line" }}
              dangerouslySetInnerHTML={{
                __html: `ezyLegal has client-focused lawyers and the best advocates who take a practical and comprehensive approach to alimony and maintenance-related matters. We help you with informative legal advice and assistance in managing such matters. Our legal services are high-quality, affordable, and on-demand.            

              Consult ${city}’s top-rated alimony and maintenance lawyers, who have a wide range of experience practicing in the High Court and before the Supreme Court of India. We will connect you with legal attorneys in ${city} and nearby areas’ legal experts who are knowledgeable and well-informed about family law.
              
              Connect now with legal consultants from your nearest location in ${city} that best suits you.`,
              }}
            />
          )}
          {concernedArea == "Cheque Bounce" && (
            <Text
              as="div"
              fontSize={"mdl"}
              weight="400"
              color="secondary2"
              style={{ whiteSpace: "pre-line" }}
              dangerouslySetInnerHTML={{
                __html: `Cheque bounce is a financial offence that may have serious repercussions for the issuer.ezyLegal's expert cheque bounce advocates are experienced in handling and resolving matters involving check bounces and dishonour matters. Our legal advisors have extensive knowledge of money recovery matters, charge affordable rates, and operate with the utmost transparency.            

              Our attorneys in ${city} are experts in handling situations of cheque bounce and helps in drafting legal and cheque bounce notices. The platform supports eight Indian languages, which makes it easier for customers to interact with lawyers in their regional language.
              
              Connect with ${city}’s top attorneys who litigate in important legal forums, including the High Court, Supreme Court, Debt Recovery Tribunals, and others. Our mission is to connect you with a lawyer who will provide the right legal advice.  Find  ezyLegal's top-rated legal experts and the best cheque bounce lawyers in ${city} for legal consultation.`,
              }}
            />
          )}
          {concernedArea == "Corporate" && (
            <Text
              as="div"
              fontSize={"mdl"}
              weight="400"
              color="secondary2"
              style={{ whiteSpace: "pre-line" }}
              dangerouslySetInnerHTML={{
                __html: `ezyLegal's company lawyers provide experienced legal advice on diverse range of businesses be it small or large, all aspects of company law, including corporate transactions, company incorporation, mergers and acquisitions, joint ventures, and on corporate reorganization. We also help in drafting legal documents, and offer regulatory and corporate compliance solutions.            

              Our attorneys have a great deal of experience in the High Court, the Income Tax Appellate Tribunal, the National Company Law Tribunal, the National Company Law Appellate Tribunal, and the Supreme Court of India. Our legal advisors from ${city} understand various business obstacles and the legal concerns that accompany them.
              
              Our legal advisors take an interest in your legal matters, provide tailored advice, and offer assistance in company-related matters. Find the best company lawyers in ${city} and nearby areas. Connect with corporate lawyers from your nearby location in ${city}.`,
              }}
            />
          )}
          {concernedArea == "Criminal" && (
            <Text
              as="div"
              fontSize={"mdl"}
              weight="400"
              color="secondary2"
              style={{ whiteSpace: "pre-line" }}
              dangerouslySetInnerHTML={{
                __html: `ezyLegal’s highly experienced team of Criminal Lawyers in ${city} offer you the right advice, help, and representation whenever and wherever required.           

              Criminal attorneys on our platform are the and best in ${city}, enabling our clients to acquire practical legal advice and support. We provide a comprehensive range of legal services in the areas of white collar crimes and blue collar crimes. The right kind of legal advice is given to corporations and individuals on intellectual property crimes, cyber crimes, or other legislation with criminal provisions combined. 
              
              One can seek consultation for criminal matters in eight national languages from our team of top-rated legal advisors from across the nation. Connect with legal consultants at the location in ${city}  and nearby areas that best suits you.`,
              }}
            />
          )}
          {concernedArea == "Cyber Crime" && (
            <Text
              as="div"
              fontSize={"mdl"}
              weight="400"
              color="secondary2"
              style={{ whiteSpace: "pre-line" }}
              dangerouslySetInnerHTML={{
                __html: `Cybercrime is criminal activity that is committed through the use of the internet or computer.ezyLegal’s cyber crime attorneys are highly qualified to assist you on your case and obtain the best possible conclusion.           

              Our advocates from ${city} deal with a variety of  offences that include using a computer to perform hacking, spamming, spreading viruses, phishing, and fraud. Our legal advisors have experience successfully defending a wide range of serious criminal offences.We are  solution-driven, pragmatic service on online platform that is  known for the quality of its legal services and responsiveness. 
              
              Our associates and customers benefit from our flexible pricing structures and inventive case management strategies. ezyLegal has legal advisors from across the nation. Speak with legal consultants from ${city} and nearby areas now.`,
              }}
            />
          )}
          {concernedArea == "Debt Recovery" && (
            <Text
              as="div"
              fontSize={"mdl"}
              weight="400"
              color="secondary2"
              style={{ whiteSpace: "pre-line" }}
              dangerouslySetInnerHTML={{
                __html: `Our Debt recovery Legal Experts are accomplished lawyers who deal with individuals for  timely recovery of their debts by providing regular, trending, and practical guidance. The attorneys have years of courtroom expertise in key legal forums like the High Courts, Supreme Court, Debt Recovery Tribunals .We have a 100% success rate so far, and Our recovery service is efficient and cost-effective.
              and every petition we have made has been settled in our client's favor.                         

              As online platform ezyLegal offers services such as drafting legal notices and cheque bounce notices and provides legal consultation.We help you consult attorneys in ${city} who have earned a reputation for providing high-quality, client-centered solutions. 
              
              Debt recovery lawyers in ${city} use a specific and strategic methodology to quickly recover your money, while taking into account the need to maintain your client relationships and reputation.`,
              }}
            />
          )}
          {concernedArea == "Direct Tax" && (
            <Text
              as="div"
              fontSize={"mdl"}
              weight="400"
              color="secondary2"
              style={{ whiteSpace: "pre-line" }}
              dangerouslySetInnerHTML={{
                __html: `Advocates at ezyLegal are experienced and they regularly appear in High Courts and Supreme Court of India. Our team is comprised of the best of Lawyers, Chartered Accountants, Company Secretaries, and Tax Specialists who have the expertise and experience of providing taxation advisory services.                         

              Our income tax team covers all areas of direct and corporate tax needs. These services include tax assessments, tax advising, structuring and investment strategy, due diligence, and litigation. Attorneys in ${city} advise taxpayers on corporate reorganization, the formation of new entities, income tax, royalties and fees for technical services, transfer pricing, and contracting.
              
              Our Direct tax Advocates are available 24x7 and provide consultation in 8 regional languages. Talk to ezyLegal advisors based in ${city} and nearby areas. Visit ezyLegal <a>www.ezylegal.in</a> to consult direct tax lawyers in ${city} and nearby areas for the best legal advice.`,
              }}
            />
          )}
          {concernedArea == "Family" && (
            <Text
              as="div"
              fontSize={"mdl"}
              weight="400"
              color="secondary2"
              style={{ whiteSpace: "pre-line" }}
              dangerouslySetInnerHTML={{
                __html: `Family lawyers are accomplished advocates based in <Delhi > who will give compassionate and helpful assistance with your family law case from start to finish. Our family attorneys handles the  disputes ranging from matrimonial issues such as divorce, domestic violence, judicial separation, restitution of conjugal rights, and child custody battles to issues of adoption,  alimony or maintenance.                          

              Our family attorneys in ${city} deal with  various marital  disputes. We provide outstanding service in  handling  your case effectively and personally, at affordable rates. 
              Get legal advice on family concerns in ${city}  from lawyers, with immense experience practicing in the High Courts and before the Supreme Court of India.
              
              ezyLegal’s skilled legal advisor and the best property family lawyers in ${city} offer legal assistance 24x7 . For  the right kind of legal advice speak  to the top rated family law  advocates in ${city} and have your queries answered instantly.`,
              }}
            />
          )}
          {concernedArea == "Gst" && (
            <Text
              as="div"
              fontSize={"mdl"}
              weight="400"
              color="secondary2"
              style={{ whiteSpace: "pre-line" }}
              dangerouslySetInnerHTML={{
                __html: `ezyLegal is a full-service platform with an excellent mix of advisory and dispute resolution expertise in GST and commercial matters.                         

              The team specialize in GST laws and complex tax issues, and they can provide commercially viable solutions.
              
              Our ${city} based GST lawyers have a wealth of experience in the High Court, Supreme Court, Debt Recovery Tribunals.
              Consult ${city}’s  proficient trained GST experts, who handle the difficult and frequently complicated area of Indian law and regulation.
              
              The lawyers take a pragmatic approach to finding solutions that work to achieve all objectives.Our ${city} based GST experts are available round the clock and will answer queries with utmost sincerity and dedication. Speak to the best legal experts from ${city} and nearby areas.`,
              }}
            />
          )}
          {concernedArea == "Investment And Fundraise" && (
            <Text
              as="div"
              fontSize={"mdl"}
              weight="400"
              color="secondary2"
              style={{ whiteSpace: "pre-line" }}
              dangerouslySetInnerHTML={{
                __html: `ezyLegal’s investment and fund raise lawyers work with start-ups and early-stage investors, offering cost-effective and efficient help throughout the fund-raising process, limiting the impact of high-risk issues while facilitating the transaction by resolving  risks along the way. Our ${city} based legal advisors develop inventive strategies to ensure the best outcome and contribute to  company growth to the greatest extent possible.                   

              Our platform offers  services that include legal due diligence, fund raise documentation and compliance, and working with the investee to complete conditions and actions as needed for raising funds and investments. We also assist clients with fund formation and structuring for asset classes including seed funds, venture funds, private equity, infrastructure funds, debt funds, and other special funds.
              
              The advocates are available 24/7 and ensure transparency, efficiency, confidentiality, and responsibility.Connect with the best fund raise lawyers in ${city} and nearby areas for expert legal advice.`,
              }}
            />
          )}
          {concernedArea == "Property" && (
            <Text
              as="div"
              fontSize={"mdl"}
              weight="400"
              color="secondary2"
              style={{ whiteSpace: "pre-line" }}
              dangerouslySetInnerHTML={{
                __html: `Property attorneys at ezyLegal offer a wide range of legal services and representation to clients in property-related situations. The  right and neutral advice on  property disputes matters is provided by Legal advisors. Our property attorneys in ${city} will work hard to gather critical evidence for your case and assist you in obtaining approvals quickly.ezyLegal has renowned advocates with experience representing clients in various High courts and  the Supreme Court.

              A wide range of services, such as property registration, property verification, and legal advice on property leasing and renting, drafting services for documents like rent agreements, sale deeds, gift deeds, and other property and real estate documents are available on our platform.
              
              Our commitment to delivering exceptional customer service has also been recognised across the legal and financial service sectors. Avail ezyLegal’s lawyer consultation services and Talk to the best Property advocates from ${city} on phone and have your queries answered instantly. `,
              }}
            />
          )}
          {concernedArea == "Rera Act" && (
            <Text
              as="div"
              fontSize={"mdl"}
              weight="400"
              color="secondary2"
              style={{ whiteSpace: "pre-line" }}
              dangerouslySetInnerHTML={{
                __html: `Protecting the interests of homebuyers by adhering to the RERA Act is a very important process while buying a home. To safeguard the interests of customers, real estate transactions must be efficient and transparent.

              ezyLegal has qualified RERA lawyers and specialist property lawyers who help you through the process, offering safe, sound, and reliable guidance from the beginning of your transaction to the final registration of your house.
              
              Our ${city} based advocates provide legal advice on Real estate and Property laws advisory and compliances offering total legal assistance in property litigations, disputes and documentations for Property disputes and litigation, drafting various types of property documentations,Registration compliances of properties and adjudications of stamp duties.
              
              Get practical legal advice from ezyLegal's best RERA lawyers in ${city}. Talk to the best RERAadvocates in ${city} and have your queries answered instantly. `,
              }}
            />
          )}
          {concernedArea == "Labour And Employment" && (
            <Text
              as="div"
              fontSize={"mdl"}
              weight="400"
              color="secondary2"
              style={{ whiteSpace: "pre-line" }}
              dangerouslySetInnerHTML={{
                __html: `Employment law experts at ezyLegal advise a diverse spectrum of small and privately owned firms, as well as big financial organisations. 

              Our ${city} based advocates provide commercially oriented and practical advice on areas and events such as change of ownership, employee benefits, employment agreements and policies,  and workplace diversity and discrimination issues.
              
              Our online platform provides services such as consultation for HR and labour compliance,  employment contracts, consulting agreements, ESOP policy,  POSH policy, and maternity policy. We also offer drafting services for employment contracts that can be customised along with document review.
              
              Consult ${city}’s top-rated highly experienced employment and labour experts who practice in various High courts and before the Supreme Court of India
              The advocates are available 24x7. Find the best labour and employment lawyers from ${city} and nearby areas.`,
              }}
            />
          )}
          {concernedArea == "Nclt Matter" && (
            <Text
              as="div"
              fontSize={"mdl"}
              weight="400"
              color="secondary2"
              style={{ whiteSpace: "pre-line" }}
              dangerouslySetInnerHTML={{
                __html: `ezyLegal's NCLT team is led by experienced corporate attorneys who  have acquired skills and experience in dealing with compliance concerns and assist by providing simple solutions as well as frequent evaluations of corporate needs.

              We have renowned corporate lawyers who have a wide range of experience practicing in the High Court and Supreme Court and are based in ${city}. Corporate lawyers on our platform represent clients before the National Company Law Tribunal (NCLT), providing litigation support and counselling services. They also handle insolvency, corporate disputes, employee and labor demands, bankruptcies, and other actions 
              
              Our NCLT team of advisors in ${city} and nearby areas provide right advice round the clock. . Visit ezyLegal <a href="https://www.ezylegal.in/" style="color : #007bff">www.ezylegal.in</a> to Consult NCLT Lawyers in ${city} and nearby areas for the best legal advice.`,
              }}
            />
          )}
          {/* {concernedArea && concernedArea !== 'Business' && (
          <Text
            as="div"
            fontSize={"mdl"}
            weight="400"
            color="secondary2"
            style={{ whiteSpace: "pre-line" }}
            dangerouslySetInnerHTML={{
              __html: `ezyLegal is an Indian legal technology company that provides online legal services on all legal matters. Our website is based upon well-read and well-versed lawyers, who are there to cater to yourall legal needs. <strong>We help you to consult and hire an experienced lawyer in ${city}.</strong> Through our website, you can find <strong>${city}’s best advocate</strong> for your legal matter. <strong>Consult lawyers in ${city} and nearby areas</strong> and get round-the-clock legal assistance from India's top lawyers in ${city}. You can ask your queries online and have them answered by top advocates in India. Googling your legal questions may not be an option in your case. With ezyLegal&'s legal advice service, you can <strong>talk to top-rated lawyers in ${city}</strong> about your legal issue and receive a practical solution. At ezyLegal, we provide the best set of Lawyers covering various areas of expertise. <strong>Hire an experienced lawyer to get the best and right legal advice instantly in ${city}.</strong>            

            There are 9,000+ ezyLegal verified experts who can help you to get your work done in a well-defined time. Various Senior Lawyers practising in High Courts and Supreme Courts are connected with us. They are 24x7 Available and Support 8 Indian Languages. ezyLegal maintains 100% Confidential & Secure your matter.`,
            }}
          />
        )} */}
          {!concernedArea && (
            <Text
              as="div"
              fontSize={"mdl"}
              weight="400"
              color="secondary2"
              style={{ whiteSpace: "pre-line" }}
              dangerouslySetInnerHTML={{
                __html: `ezyLegal is an online legal service platform that provides legal services for all your legal matters. We help you to get legal advice and hire an experienced lawyer in ${city}. Through our website, you can consult ${city}’s best advocate for your legal matter. Consult lawyers in ${city} and nearby areas and get round-the-clock legal assistance from the top-rated lawyers in ${city}. Googling your legal questions may not give you the right legal advice. Hire an experienced lawyer to get the best and right legal advice instantly in ${city}.         

              There are 9,000+ ezyLegal verified experts who can provide you with legal services within a well-defined time. Various Senior Lawyers practising in High Courts and Supreme Courts are registered on our platform. They are available 24x7 and can talk in 8 Indian Languages. ezyLegal provides 100% Confidentiality & your conversations with lawyers are private and secured.`,
              }}
            />
          )}

          {urlYoutube && (
            <iframe
              width="100%"
              allowFullScreen
              style={{ aspectRatio: "16/9" }}
              src={`${urlYoutube}?controls=1&showinfo=1&rel=0&iv_load_policy=3`}
              title={`YouTube video ${concernedArea}`}
            />
          )}

          {showMore && (
            <>
              {concernedArea == "Business" && (
                <CityLawyerComponent
                  title={` ${concernedArea} lawyers in ${city}`}
                  content={`ezyLegal is an interactive online platform that makes it faster and easier to find top-rated business legal consultants in ${city} who will give you the right advice. Our approach is well suited for startups & small businesses. ezyLegal advocates are qualified and experienced legal professionals, who can provide you with the right legal advice for Company Matters, Trademark & Copyrights, Law & Regulation, Investment & Fundraise, Taxation & Compliance, or getting your Term Sheet & Shareholder Agreement reviewed. 

              Consult ${city}’s top-rated business legal experts, who have a wide range of experience practicing in the High Court and before the Supreme Court of India.
              
              The advocates are available 24x7. Find the best business legal consultation lawyers from ${city} and nearby areas.`}
                />
              )}
              {concernedArea == "Divorce" && (
                <CityLawyerComponent
                  title={`Find the Best Divorce and Custody lawyers in ${city}`}
                  content={`Through ezyLegal’s online platform get practical legal advice on family-related matters such as divorce, child custody, annulment, and restitution of conjugal rights. Our team of lawyers in and around ${city} are committed to providing the best possible solution for your individual case. We protect your rights, offer focused advice, personal empathy, and attention and ensure full confidentiality is maintained during your family law proceedings. 

              Our team also includes trustworthy and compassionate female Divorce and Child Custody Attorneys who have the legal expertise and can offer top-notch advice.
              
              Our Divorce and Child Custody Advocates are available round the clock, Talk to ezyLegal advisors based in ${city} and nearby areas. Visit ezyLegal <a href="https://www.ezylegal.in/" style="color : #007bff">www.ezylegal.in</a> to Consult Family Lawyers in ${city} and nearby areas for the best legal advice.`}
                />
              )}
              {concernedArea == "Property Disputes" && (
                <CityLawyerComponent
                  title={`Find the Best Property Disputes lawyers in ${city}`}
                  content={`ezyLegal advocates strive to provide outstanding services to all the clients in resolving  the issues related to property disputes .The ${city} based attorneys specialize in property matters related to both common law and civil law. 

              We deal with services such as the registration of wills, power of attorney, ownership changes, and other situations linked to property disputes. ezyLegal has the best property dispute advocates in ${city} who provide on-demand legal services for all needs. 
              
              With ezyLegal, our group of legal advisors who have practised in the High Court and Supreme Court and are based in ${city}provides you with the finest document drafts and agreements at a very low and affordable rate.We make legal consultations simple, practical, and easy by serving as your middlemen. Consult top-rated legal consultants in ${city} and nearby areas for property disputes. `}
                />
              )}
              {concernedArea == "Trademark And Copyrights" && (
                <CityLawyerComponent
                  title={`Find the Best Trademark and Copyrights lawyers in ${city}`}
                  content={`As an online platform, ezyLegal has given solution-driven legal services to both large & medium-sized organizations. With the ongoing changes in the commercial world, ezyLegal’s team of Trademark and Copyright attorneys and legal consultants in ${city} are ideally suited to fulfil the constantly changing requirements and needs of our clients.

              Our Trademark and Copyright lawyers with immense experience & expertise provide services for trademark registration, trademark renewal, response to trademark objections, and copyright registrations. 
              
              Get practical legal advice and help from ezyLegal's top-rated legal experts and the best trademark and copyright attorneys in ${city}. Our associates and clients benefit from our flexible pricing structures and inventive case management strategies. ezyLegal has legal advisors from across the nation. `}
                />
              )}
              {concernedArea == "Consumer Protection" && (
                <CityLawyerComponent
                  title={`Find the Best Consumer Protection lawyers in ${city}`}
                  content={`ezyLegal has approachable, and dedicated legal advisors who work hard to give our customers the best possible service by comprehending their needs, acting quickly, and keeping their promises.

              The attorneys in ezyLegal appear regularly before the District Courts, High Court and National Consumer Disputes Redressal Commission and have immense knowledge in consumer-related matters. 
              
              Consult ${city}’s top consumer protection advocates who handle a wide range of areas, including consumer fraud, product liability, false advertising, and other business scams. We are on a mission to make legal services high-quality, cost-effective, and available on demand for every need.
              
              The advocates are available 24x7 and ensure transparency, efficiency, confidentiality and responsibility. Visit ezylegal <a href="https://www.ezylegal.in/" style="color : #007bff">www.ezylegal.in</a> and connect with the best consumer protection lawyers in ${city} and nearby areas for expert legal advice.`}
                />
              )}
              {concernedArea == "Will" && (
                <CityLawyerComponent
                  title={`Find the Best Will lawyers in ${city}`}
                  content={`ezyLegal provides Will writing services in a variety of formats, including online and customized services. ezyLegal has onboarded skilled Will attorneys that can design your customized Will based on your specific needs and requirements. 

              Our legal advisors also assist with Will-related documents. Consult top-rated legal advisors from your area in ${city} who are available 24x7 to give you the right advice. Our online Will writing service is simple to use and personalized to your specific needs.  
              
              With our steadfast belief that customer satisfaction is just as important as its products and services, this company has amassed a sizable client base that is just continuing to grow. Talk to the best Will drafting advocates from ${city} and nearby areas on phone and have your queries answered instantly.
              
              `}
                />
              )}
              {concernedArea == "Alimony And Maintenance" && (
                <CityLawyerComponent
                  title={`Find the Best Alimony and Maintenance lawyers in ${city}`}
                  content={`Many of our clients have successfully negotiated alimony and maintenance support terms with the help of our subject matter expert lawyers. Our experienced alimony and maintenance attorneys help clients with maintenance and alimony cases in an informed, and proactive manner. 

              We work together to ensure that our clients receive the same level of representation that we would demand ourselves. Consult ${city}’s top-rated alimony and maintenance lawyers for the right kind of legal advice.  
              
              The advocates are available 24/7 and ensure transparency, efficiency, confidentiality and responsibility. Visit ezylegal <a href="https://www.ezylegal.in/" style="color : #007bff">www.ezylegal.in</a> and connect with the best alimony and maintenance lawyers in ${city} and nearby areas for expert legal advice.
              
              `}
                />
              )}
              {concernedArea == "Cheque Bounce" && (
                <CityLawyerComponent
                  title={`Find the Best Cheque Bounce lawyers in ${city}`}
                  content={`Our team of Best and Top Cheque Bounce Lawyers and Advocates in ${city} provides our client with a simple and hassle-free solution. They assist the client by educating them on the implications of this case and drafting legal and cheque bounce notices.

              ezyLegal advocates are experts in dealing with cheque bounce cases as we have been successful in defending our clients and providing them with support. Our Cheque Bounce Lawyers and Advocates in ${city} have been instrumental in assisting our clients in a number of cheque cases.
                
              `}
                />
              )}
              {concernedArea == "Corporate" && (
                <CityLawyerComponent
                  title={`Find the Best Corporate lawyers in ${city}`}
                  content={`We provide successful services to our customers by combining extensive knowledge of corporate law with experience. We provide total client satisfaction by recognizing  difficulties and offer real-time, practical solutions to corporate transactions, company incorporation, mergers and acquisitions, joint ventures, and corporate reorganization.

              Consult ${city}’s top-rated corporate lawyers who have a wide range of experience practicing in the High Court and before the Supreme Court of India. The advocates are available 24x7. Find the best business legal consultation lawyers from ${city} and nearby areas.
                
              `}
                />
              )}
              {concernedArea == "Criminal" && (
                <CityLawyerComponent
                  title={`Find Criminal lawyers in ${city}`}
                  content={`Seek  practical legal advice and support from criminal lawyers who specialize in criminal litigation and represent clients in several Indian courts. 

              ezyLegal's advocates are among the top rated criminal attorneys in ${city}who handle cases involving banking frauds, intellectual property fraud, violations of cyber laws, and other financial crimes. As a full-service legal platform, we offer the highest level of criminal defence legal services as our criminal attorneys are well-known for their expertise and attention to detail.
                
              Consult ${city}’s criminal experts, who have a wide range of experience practicing in the High Court and before the Supreme Court of India.The advocates are available 24x7. Find the best criminal lawyers from ${city} and nearby areas.`}
                />
              )}
              {concernedArea == "Cyber Crime" && (
                <CityLawyerComponent
                  title={`Find Cyber Crime lawyers in ${city}`}
                  content={`Cybercrime is a broad and ever-changing field of law that can be far more diverse than a mere criminal case. 

              Our advocates have the training and experience to understand how computer technology relates to cyber law.  ezyLegal’s ${city}based cyber crime attorneys keep current as Indian computer crime laws evolve to include these new computer and technology-based offences.
                
              When it comes to your need for Cyber Crime Lawyers & Legal Consultants, simply reach out to us with the necessary information, and we will present a list of Cyber Crime Lawyers & Legal Consultants near you in ${city}.`}
                />
              )}
              {concernedArea == "Debt Recovery" && (
                <CityLawyerComponent
                  title={`Find Debt Recovery lawyers in ${city}`}
                  content={`ezyLegal’s understanding of the most recently revised commercial legislation guarantees you the justice needed to get back to normal business promptly and effectively.Our attorneys specialize in recovering outstanding debts from individuals and businesses, so we know the best strategy to recover your unpaid debts fast, which may include bankruptcy processes, litigation, or an out-of-court settlement. 

              Consult ${city}’s top-rated Debt recovery who have a wide range of experience practicing in the High Court and before the Supreme Court of India. The advocates are available 24x7. Find the Debt recovery lawyers from ${city} and nearby areas.`}
                />
              )}
              {concernedArea == "Direct Tax" && (
                <CityLawyerComponent
                  title={`Find Direct Tax lawyers in ${city}`}
                  content={`ezyLegal's team of direct tax experts can handle taxation concerns of any complexity and   offer comprehensive 'Tax Solutions' for conducting business inside and with India through advising, litigation, and compliance services.

              Our attorneys also appear before authorities and courts, including the High Court and the Supreme Court. Our legal advisors provide effective litigation preparation for our clients.  In addition to standard litigation services, ezyLegal offers support services for high-stakes cases, providing impartial assessment and feedback .
              
              The right kind of legal advice for Direct tax matters is provided from our team of top-rated legal advisors from across the nation. Connect with legal consultants at the location in ${city} that best suits you.`}
                />
              )}
              {concernedArea == "Family" && (
                <CityLawyerComponent
                  title={`Find Family lawyers in ${city}`}
                  content={`Our ${city} based advocates have a solid reputation for success and provide outstanding service and quality representation to our clients. Our attorneys respect your privacy and confidentiality therefore, all your conversations with lawyers are secure and private.

              Consult Top Rated Family Lawyers in ${city} for Correct and Neutral Advice on Family Matters. Our Family Lawyers will provide you with sound assistance on any of the following issues.`}
                />
              )}
              {concernedArea == "Gst" && (
                <CityLawyerComponent
                  title={`Find GST lawyers in ${city}`}
                  content={`Our Legal Experts are accomplished lawyers who offer legal consultation services for individual clients and businesses with issues relating to GST and tax. We provide support in 8 Indian Languages. ezyLegal provides 100% Confidentiality by keeping your conversations with lawyers secure and private.

              We offer solutions to all individuals, businesses, corporate bodies, and others in order for them to receive better assistance for the problems they are experiencing.
              
              For consultation with our network of legal GST experts in ${city} and nearby areas log on to the ezylegal website <a href="https://ezylegal.in/" target="_blank" style="color : #007bff" rel="noopener noreferrer">www.ezylegal.in</a>.`}
                />
              )}
              {concernedArea == "Investment And Fundraise" && (
                <CityLawyerComponent
                  title={`Find Investment and Fundraise lawyers in ${city}`}
                  content={`ezyLegal advocates have the best investment and fund practices and provide legal assistance to public and private funds and fund sponsors, fund boards and trustees, service providers, and other industry players on problems ranging from ordinary to complex.

              Whether you are a huge financial institution with global operations or a boutique enterprise looking to stay competitive, ezyLegal's team of investment and fund raising practitioners can assist you in reaching your goals.
              
              To address all your legal concerns and uncertainties,Visit www.ezyLegal.com and talk to investment and fundraise lawyers from ${city} and nearby areas. Connect with ezyLegal for the right legal advice from ${city} based lawyers.`}
                />
              )}
              {concernedArea == "Property" && (
                <CityLawyerComponent
                  title={`Find Property lawyers in ${city}`}
                  content={`ezyLegal provides a specialized team of competent  property attorneys in ${city}. We are completely committed to ensuring that our clients meet all of the standards for real estate and property matters. Our platform supports 8 Indian languages for easy communication and online consultation with lawyers.

              We  connect you with a top-rated legal experts and the best property lawyers in ${city} for legal consultation.`}
                />
              )}
              {concernedArea == "Rera Act" && (
                <CityLawyerComponent
                  title={`Find RERA lawyers in ${city}`}
                  content={`ezyLegal provides the best solutions and devise ways that will help you win the case with ease at an affordable price. Our attorneys have extensive experience managing RERA matters, which explains why we are the best. 

              We provide right advice and assistance of good RERA suit lawyers to defend the case against real estate developers. 
              
              Consult top-rated RERA  lawyers from your area in ${city} who will give you the right and neutral advice.Find the best legal experts in ${city}.
              `}
                />
              )}
              {concernedArea == "Labour And Employment" && (
                <CityLawyerComponent
                  title={`Find Labour and Employment lawyers in ${city}`}
                  content={`Our experienced employment lawyers provide employers with practical and proactive advice on all major legal and regulatory aspects of employment and the employer-employee relationship.

              Legal advisors at ezyLegal helps in  minimising the risk of litigation and assist  in balancing legal compliance requirements with business objectives. 
              
              We ensure the whole process is highly confidential, transparent and efficient. Log on to ezylegal and connect with the best consumer protection lawyers in ${city} and nearby areas for expert legal advice.`}
                />
              )}
              {concernedArea == "Nclt Matter" && (
                <CityLawyerComponent
                  title={`Find NCLT lawyers in ${city}`}
                  content={`Suitable guidance and assistance is provided  at ezylegal to our clients in situations involving NCLT-related matters, as described above. We make things easier for you and provide trustworthy and affordable corporate compliance services .

              Our NCLT advocates  guarantee timely service that will keep you secure and legally viable in your operations.Our efforts, methods, and services are all aimed toward achieving customer success and happiness.
              
              Get practical legal advice for all corporate disputes and matters from top-rated legal experts and the best NCLT attorneys in ${city}.`}
                />
              )}
              {/* <CityLawyerComponent
              title={`Find the best${
                concernedArea ? ` ${concernedArea}` : ""
              } lawyers in ${city}`}
              content={`A lawyer’s experience and approach is the most critical aspect of his reputation and it is important for the success & right handling of your matter. Now Talk to best ${
                concernedArea ? ` ${concernedArea}` : ""
              } Lawyers from ${city} and consult your matter with them before even filing a matter. Ezylegal associate lawyers adopt an approach to first identify your exact legal need. We highly recommend you to consult a lawyer about your problem before hiring one. This way you will be able to take a better legal decision. That will save your money and time. Ezylegal through its Just Consult Technology product will help you connect with the top ${
                concernedArea ? ` ${concernedArea}` : ""
              } lawyers in ${city}. You can speak to senior advocates from ${city} High Court and Supreme Court and discuss your legal matter before taking a decision on your matter. Talk to the best ${
                concernedArea ? ` ${concernedArea}` : ""
              } advocates in ${city} for your legal matter. Get immediate and right guidance over the phone from an expert ${
                concernedArea ? ` ${concernedArea}` : ""
              } lawyer instantly. Some issues just can't wait. If you need a resolution right away, then consult with a Ezylegal lawyer immediately.`}
            /> */}
              {!concernedArea && (
                <>
                  <CityLawyerComponent
                    title={`Find the Best lawyers in ${city}`}
                    content={`We will assist you to consult and speak to senior advocates from ${city}. We have Lawyers with an excellent reputation in ${city} who can provide you the advice & representation for your legal issues. Talk to the best advocates in ${city}, ask your query, and get answers. The replies are quick and prompt and give a clear understanding of the law that surrounds your concerns. Get lawyer advice from ${city}-based lawyers for your legal queries using the legal advice service through the website, where more than 5 Lakh people have benefitted.`}
                  />
                  <CityLawyerComponent
                    title={`Choose an Advocate as Per the Practice Type`}
                    content={`ezyLegal is a one-stop website where you can choose advocates as per practice type and get legal advice from ${city}’s top attorney and also you can select ${city}'s best advocate for a wide range of legal services. Our legal consultants in ${city} are available 24 x 7. Get legal advice from ${city}-based advocates whose advice is tailored to your specific requirements. Ask your query and get it answered by an expert in your concerned area.`}
                  />
                  <CityLawyerComponent
                    title={`Find Lawyers for Property Matters in ${city}`}
                    content={`When it comes to real estate, you should consult an expert property lawyer who can handle complicated paperwork for you. The advocate will guide you through the tedious process of the sale or purchase of the property.
                  
                  Without a doubt, ezyLegal is your one-stop shop for all issues involving real estate or property. We strive to be the first choice for clients looking for outstanding <a href="https://www.ezylegal.in/city-lawyers/find-property-lawyers-in-${city?.toLowerCase().replace(/ /g, "-")}" style="color : #007bff">legal advice from ${city}-based property matter legal experts</a> with a wealth of knowledge in both common and civil law, particularly regarding matters involving property.
                  
                  We have renowned real estate lawyers who have experience practising in the High Court and Supreme Court. Our advocates provide services like property registration, property verification, and legal advice on property leasing and renting.`}
                  />
                  <CityLawyerComponent
                    title={`Divorce Lawyers in ${city}`}
                    content={`<a href="https://www.ezylegal.in/city-lawyers/find-divorce-lawyers-in-${city?.toLowerCase().replace(/ /g, "-")}" style="color : #007bff">Consult ${city}’s top-rated divorce lawyers</a>, who have a wide range of experience practising in various courts in and around ${city}, High Courts &  the Supreme Court of India. 
                  
                  Connect with Divorce advisors from your nearby location in ${city}. The Divorce Advocates from ${city} can advise you for marital disputes, divorce & separation, child custody, maintenance, property disputes, and family settlements. `}
                  />
                  <CityLawyerComponent
                    title={`Family Lawyers in ${city}`}
                    content={`ezyLegal is an online platform that makes it faster and easier to <a href="https://www.ezylegal.in/city-lawyers/find-family-lawyers-in-${city?.toLowerCase().replace(/ /g, "-")}" style="color : #007bff">find top-rated family law experts in ${city}</a>. We connect you with the best family lawyers in ${city} who are experienced and are practising in the High Courts and Supreme Court of India. Depending on the concerned area you select, you will be connected to a lawyer instantly.
                  
                  Our experts specialize in family-related matters such as divorce, annulment, restitution of conjugal rights, maintenance, alimony, dowry harassment cases, domestic violence matter etc. Visit the ezylegal website <a href="https://www.ezylegal.in/" style="color : #007bff">www.ezylegal.in</a> to consult family lawyers in ${city} and nearby areas.`}
                  />
                  <CityLawyerComponent
                    title={`Consult Criminal Lawyers in ${city}`}
                    content={`A criminal defence lawyer will help clients receive a fair trial. ezyLegal advocates possess good experience enabling them to provide clients with efficient and result-oriented solutions. <a href="https://www.ezylegal.in/city-lawyers/find-criminal-lawyers-in-${city?.toLowerCase().replace(/ /g, "-")}" style="color : #007bff">Consult top-rated criminal lawyers practising in ${city}’s</a> Criminal and Family courts. Our legal advisors have extensive knowledge of both criminal law and corporate criminal matters, charge affordable rates and operate with the utmost transparency.
                    
                  Consult top-rated criminal lawyers from your area in ${city} who will give you the right and neutral advice. We have more than 9000+ criminal lawyers who are registered and are ezyLegal-verified experts practising in the various courts in ${city}.
                    
                  We deal with various criminal issues, such as cybercrime, financial disputes, and white-collar crimes. Avail ezyLegal’s lawyer consultation services and Talk to the Best Criminal Advocates from ${city} on phone and have your queries answered instantly.`}
                  />
                  <CityLawyerComponent
                    title={`Employment & Labour Law Expert Lawyer in ${city}`}
                    content={`ezyLegal’s employment law experts advise a diverse spectrum of small and privately owned firms, as well as big financial organizations. Our ${city} based advocates provide practical advice on areas and events such as change of ownership, employee benefits, employment agreements and policies, and workplace diversity and discrimination issues.
                    
                  We have some of the best labour and employment lawyers who have a wide range of experience practicing in various High courts and before the Supreme Court of India. ezyLegal also provides services such as consultation for HR and labour compliance, employment contracts, consulting agreements, ESOP policy,  POSH policy, and maternity policy. Our platform also offers drafting services for employment contracts that can be customized, along with document review.
                    
                  Our legal advisors assist clients in balancing legal compliance requirements with business objectives and promoting their workplace culture and values while minimizing the risk of litigation. <a href="https://www.ezylegal.in/city-lawyers/find-labour-and-employment-lawyers-in-${city?.toLowerCase().replace(/ /g, "-")}" style="color : #007bff">Consult ${city}’s top-rated employment and labour experts</a>, who are available 24x7.`}
                  />
                </>
              )}
            </>
          )}
          {showMore && (
            <div>
              <HeadingText2
                fontSize="lg"
                fontFamily="montserrat"
                weight="bold"
                className="mb-3"
              >
                Other Requirements in Your Area
              </HeadingText2>
              <div>
                {concernedAreas &&
                  concernedAreas?.map((CONCERNED_AREA: any) => {
                    return (
                      <a
                        className="sitmap-link"
                        href={`https://www.ezylegal.in/city-lawyers/find-${CONCERNED_AREA.toLowerCase().replace(
                          / /g,
                          "-"
                        )}-lawyers-in-${city.toLowerCase().replace(/ /g, "-")}`}
                      >
                        {`${CONCERNED_AREA} Lawyers and Legal Advisors in ${city}`}
                      </a>
                    );
                  })}
              </div>
            </div>
          )}
          {showMore && (
            <div className="mt-4">
              <HeadingText2
                fontSize="lg"
                fontFamily="montserrat"
                weight="bold"
                className="mb-3"
              >
                Other Cities searched for
              </HeadingText2>
              <div>
                {nextCities &&
                  nextCities?.map((citi: any, index: any) => {
                    return (
                      <a
                        className="sitmap-link"
                        href={`https://www.ezylegal.in/city-lawyers/find-lawyers-in-${citi.name
                          .toLowerCase()
                          .replace(/ /g, "-")}`}
                      >
                        {`Lawyers and Legal Advisors in ${citi.name}`}
                      </a>
                    );
                  })}
              </div>
            </div>
          )}
          <ButtonStyled
            backgroundColor="#396AE8"
            color="#fff"
            className="d-flex align-items-center justify-content-center mt-3"
            onClick={handleClickShowMore}
          >
            <Text className="mb-0">{showMore ? "Read Less" : "Read More"}</Text>
            <div
              className="d-flex align-items-center justify-content-center ml-2"
              style={{
                transform: showMore ? "rotate(-90deg)" : "rotate(90deg)",
              }}
            >
              <img
                src="/city-lawyers/icons/caretr.svg"
                alt="see-more-less-button"
                height={10}
                width={10}
              />
            </div>
          </ButtonStyled>
        </Container>
      </CorneredBox>
    </>
  );
};

export default CityLawyerHeader;
